import { useEffect, useRef, useState } from 'react';
import { VersionBlock } from './components/VersionBlock/VersionBlock';
import styles from './ReleaseNotesPage.module.css';
import { api } from '@/shared/api/api';

const ReleaseNotesPage = () => {
  const [versions, setVersions] = useState([]);
  const abortControllerRef = useRef(null);

  useEffect(() => {
    if (abortControllerRef.current) {
      abortControllerRef.current.abort();
    }

    const abortController = new AbortController();
    abortControllerRef.current = abortController;

    api
      .get('/api/releaseNotes/getReleaseNotes', {
        signal: abortControllerRef.current.signal,
      })
      .then(({ data }) => setVersions(data.releaseNotesData));

    return () => {
      if (abortControllerRef.current) {
        abortControllerRef.current.abort();
      }
    };
  }, []);

  return (
    <div className={styles.releaseNotesPage}>
      <div className={styles.pageHeading}>Release Notes</div>
      {versions.map(version => (
        <VersionBlock key={version.id} title={version.title} content={version.content} />
      ))}
    </div>
  );
};

export default ReleaseNotesPage;
